import { useEffect } from "react";
import { HashRouter, Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { useAppStore } from "./state/useAppStore";
import { BottomNav } from "./components/BottomNav";
import { ensureSeeded } from "./db/repo";
import { syncNow } from "./lib/sync/syncClient";
import { Onboarding } from "./pages/Onboarding";
import { Today } from "./pages/Today";
import { Workout } from "./pages/Workout";
import { TrainingSession } from "./pages/TrainingSession";
import { WorkoutSummary } from "./pages/WorkoutSummary";
import { Diet } from "./pages/Diet";
import { Trends } from "./pages/Trends";
import { Profile } from "./pages/Profile";
import { ExerciseLibrary } from "./pages/ExerciseLibrary";
import { PlanEditor } from "./pages/PlanEditor";
import { SettingsTraining } from "./pages/settings/SettingsTraining";
import { SettingsAccount } from "./pages/settings/SettingsAccount";
import { SettingsExport } from "./pages/settings/SettingsExport";
import { SettingsAbout } from "./pages/settings/SettingsAbout";

import { useSessionStore } from "./state/useSessionStore";

/** 尚未完成首次设置时，进入引导流程。 */
function Guard() {
  const done = useAppStore((s) => s.onboardingDone);
  const location = useLocation();
  if (!done && location.pathname !== "/onboarding") return <Navigate to="/onboarding" replace />;
  return <Outlet />;
}

/** 五个主 Tab 的布局（含底栏）。 */
function AppLayout() {
  return (
    <div className="min-h-screen mx-auto max-w-[480px]">
      <main className="px-4 pt-safe-top pb-safe-nav">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}

export default function App() {
  // 首启初始化本地库（动作库种子 + 默认设置与模板）。幂等，可重复调用。
  useEffect(() => {
    void ensureSeeded().then(() => {
      void useSessionStore.getState().hydrateFromDb();
    });
    // 阶段 4：联网时自动补同步（出站队列上传 + 增量拉取）。
    // 未配置 Supabase → syncNow 如实返回本地模式，不报错。
    if (navigator.onLine) {
      void syncNow().catch(() => {
        /* 静默：同步失败不打断首屏；用户可在「我的」页手动重试 */
      });
    }
  }, []);

  return (
    <HashRouter>
      <Routes>
        <Route path="/onboarding" element={<Onboarding />} />
        <Route element={<Guard />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Today />} />
            <Route path="/workout" element={<Workout />} />
            <Route path="/diet" element={<Diet />} />
            <Route path="/trends" element={<Trends />} />
            <Route path="/profile" element={<Profile />} />
          </Route>
          {/* 子页面与全屏页 */}
          <Route path="/library" element={<ExerciseLibrary />} />
          <Route path="/plan-editor" element={<PlanEditor />} />
          <Route path="/settings/training" element={<SettingsTraining />} />
          <Route path="/settings/account" element={<SettingsAccount />} />
          <Route path="/settings/export" element={<SettingsExport />} />
          <Route path="/settings/about" element={<SettingsAbout />} />
          <Route path="/session" element={<TrainingSession />} />
          <Route path="/summary" element={<WorkoutSummary />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}
